import { Skeleton } from "primereact/skeleton";

import S from "./_styles.module.scss";

export default function QuizSkeleton() {
  return (
    <div className={S.quizContainer}>
      <Skeleton height="2rem" width="50%" className="m-4" />
      <div className={S.quizBody}>
        <Skeleton height="1.5rem" width="75%" className="mb-4" />
        <fieldset className="flex flex-col gap-4">
          {[...Array(4)].map((_, index) => (
            <Skeleton key={index} height="1.5rem" width="100%" />
          ))}
        </fieldset>
      </div>
    </div>
  );
}
